import { AxiosPromise } from "axios"
import { usersApi } from "./api"

export const getRoles = (): AxiosPromise => usersApi("/roles")
